import axios from 'axios';
import { ServiceCookies } from '@services/ServiceCookies';
import { ServiceSpinner } from '@services/ServiceSpinner';
import config from '@app/config';

export const MyHeaders = {
  Accept: 'application/json',
  'content-type': 'application/json',
  Authorization: `Bearer ${config.apiToken}`,
  [ServiceCookies.KEY]: ServiceCookies.sessionId,
  [ServiceCookies.DEVICE_ID]: ServiceCookies.mindboxDeviceUUID,
};

export const AxiosBase = axios.create({
  baseURL: config.baseApiUrl,
  headers: MyHeaders,
  validateStatus: function (status) {
    return status < 400;
  },
});

export const MyAxios = axios.create({
  baseURL: config.baseApiUrl,
  headers: MyHeaders,
  validateStatus: function (status) {
    return status < 400;
  },
  onUploadProgress: function () {
    // Делайте все, что хотите, с родным событием прогресса
    ServiceSpinner.show();
  },
  onDownloadProgress: function () {
    // Делайте все, что хотите, с родным событием прогресса
    ServiceSpinner.hide();
  },
  // timeout: config.waitFetch,
});

export const MyAxiosSilent = axios.create({
  baseURL: config.baseApiUrl,
  headers: MyHeaders,
  validateStatus: function (status) {
    return status < 400;
  },
  onUploadProgress: function () {
    //
  },
  onDownloadProgress: function () {
    //
  },
});

export const AxiosWidget = axios.create({
  baseURL: config.baseApiUrlWidget,
  headers: {
    Accept: 'application/json',
    'content-type': 'application/json',
    'widget-uuid': config.uuidWidget,
    Authorization: `Bearer ${config.apiWidgetToken}`,
  },
});
